module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart":"График","statistic":"Статистика","total":"Общее кол-во"},"en":{"chart":"Chart","statistic":"Statistic","total":"Total"}}')
  delete Component.options._Ctor
}
